module.exports = __webpack_public_path__ + "img/XAI5.27c1f655.jpg";